/*
  Copyright 2018-2020 National Geographic Society

  Use of this software does not constitute endorsement by National Geographic
  Society (NGS). The NGS name and NGS logo may not be used for any purpose without
  written permission from NGS.

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/
import MenuItem from '@material-ui/core/MenuItem';
import MuiSelect from '@material-ui/core/Select';
import React from 'react';
import classnames from 'classnames';

interface SelectProps {
  className?: string;
  value?: string;
  options?: any[];
  onChange?: (v: any) => any;
  [any: string]: any;
}

interface SelectState {}

class Select extends React.Component<SelectProps, SelectState> {
  state = {
    value: this.props.value || this.props.options[0].value,
  };

  onChange = (e) => {
    const { onChange } = this.props;
    const { value } = e.target;
    this.setState({ value });
    onChange(value);
  };

  render() {
    const { options, className, onChange, ...rest } = this.props;
    const { value } = this.state;

    return (
      <>
        <MuiSelect
          value={value}
          onChange={this.onChange}
          className={classnames('marapp-qa-select', {
            [className]: !!className,
          })}
          {...rest}
        >
          {options.map((l) => (
            <MenuItem key={l.value} value={l.value}>
              {l.label}
            </MenuItem>
          ))}
        </MuiSelect>
      </>
    );
  }
}

export default Select;
